export default __webpack_public_path__ + "static/media/3.48573af1.png";